//  The different auth methods supported by GeoServer
export const CONNECTION_METHODS = {
    NONE: 'none',
    //X509: 'x509',
    BASIC: 'basic',
    HEADERS: 'header' //  Using our current implementation, we don't need the below value
    //HEADER_CREDENTIALS: 'header_credentials'
    //DIGEST: 'digest'
};

export const GeoserverAuthDefaults = { type: CONNECTION_METHODS.NONE };

//  Automatically generates an XMLHTTPRequest based on the auth options parsed to it
export function GeoserverImgRequest(url, authOptions, withCredentials = true) {
    authOptions = authOptions || GeoserverAuthDefaults;

    const request = new XMLHttpRequest();
    request.withCredentials = withCredentials;
    request.open('GET', url, true);
    if (authOptions.type === CONNECTION_METHODS.BASIC) {
        request.setRequestHeader(
            'Authorization',
            'Basic ' + btoa(authOptions.username + ':' + authOptions.password)
        );
    }
    if (authOptions.type === CONNECTION_METHODS.HEADERS) {
        for (const headerName in authOptions.header) {
            request.setRequestHeader(headerName, authOptions.header[headerName]);
        }
    }
    return request;
}
